<div class="meter" [ngClass]="getClass()">
  <div class="section rounded"></div>
  <div class="section rounded"></div>
  <div class="section rounded"></div>
  <div class="section rounded"></div>
  <div class="section rounded"></div>
</div>